module.exports = __webpack_public_path__ + "static/img/upgrade_depot_promotion.0ba18133.png";